import { render, staticRenderFns } from "./TemaCombobox.vue?vue&type=template&id=5cbb65ee&scoped=true"
import script from "./TemaCombobox.vue?vue&type=script&lang=js"
export * from "./TemaCombobox.vue?vue&type=script&lang=js"
import style0 from "./TemaCombobox.vue?vue&type=style&index=0&id=5cbb65ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbb65ee",
  null
  
)

export default component.exports